import { cacaClient } from '@plangrid-private/web-api-clients';
import useSWR from 'swr';

import { useCurrentProjectId } from '@adsk/alloy-provider';

import { FEATURE_FLAGS, FORMS_SWR_CONFIG } from '../helpers/constants';
import { formsClient, formsRoutes } from '../helpers/formsClient';
import getFoldersTransformers, {
  FETCH_FOLDERS_LIMIT,
} from '../helpers/transformers/getFolders';
import { getDocumentsUrl } from '../helpers/utils';
import { usePlangridFeatureFlag } from '../PlangridLaunchDarklyProvider';

export default () => {
  const projectId = useCurrentProjectId();
  const { value: isFolderMigrationEnabled } = usePlangridFeatureFlag(
    FEATURE_FLAGS.FOLDER_API_MIGRATION,
    false,
  );

  const { data, error } = useSWR(
    isFolderMigrationEnabled
      ? formsRoutes.folders(projectId)
      : getDocumentsUrl(projectId),
    async () => {
      if (isFolderMigrationEnabled) {
        const fetchFoldersRequests = [];

        const initialFoldersPage = await formsClient.getFolders(projectId, {
          offset: 0,
          limit: FETCH_FOLDERS_LIMIT,
        });

        if (!initialFoldersPage.pagination.nextUrl) {
          const { documents } = getFoldersTransformers.translateResponse([
            initialFoldersPage,
          ]);
          return documents;
        }

        const numRequests =
          Math.ceil(
            initialFoldersPage.pagination.totalResults / FETCH_FOLDERS_LIMIT,
          ) - 1;

        for (let i = 1; i <= numRequests; i++) {
          fetchFoldersRequests.push(
            formsClient.getFolders(projectId, {
              offset: FETCH_FOLDERS_LIMIT * i,
              limit: FETCH_FOLDERS_LIMIT,
            }),
          );
        }

        const foldersPages = await Promise.all(fetchFoldersRequests);

        const { documents } = getFoldersTransformers.translateResponse([
          initialFoldersPage,
          ...foldersPages,
        ]);

        return documents;
      } else {
        const { documents } = await cacaClient.documents.getAllInProject(
          projectId,
          {
            namespaces: ['field-reports'],
            document_type: 'folder',
          },
        );

        return documents;
      }
    },
    FORMS_SWR_CONFIG,
  );

  return {
    data,
    isError: error,
    isLoading: !error && !data,
  };
};
